module.exports = __webpack_public_path__ + "img/3.bc98b7cd.png";